<template>
  <div>
      <div class="flexSpaceBetween" style="text-align: center;">
        <span class="heading"><h1>{</h1></span><span class="heading" style="top: 50px; position: relative;">Trusted name, good price and amazing support</span><span class="heading"><h1>}</h1></span>
      </div>
      <div style="text-align:center; margin-top: 50px;">
        <span>
            We are one of the most trusted names amongst startup businesses. We have delivered ERPs, apps, web apps upto fully supportive End to End solutions for retail businesses such as garment manufacturers, restaurants and event management companies.
        </span>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Section1.vue